import MenuItems from './MenuItems';

export default function Dropdown({ submenus, dropdown, depthLevel }) {
  depthLevel = depthLevel + 1;

  const styles: object = {
    position: 'absolute',
    boxShadow: '0 10px 15px -3px rgba(46, 41, 51, 0.08), 0 4px 6px -2px rgba(71, 63, 79, 0.16)',
    zIndex: 9999,
    minWidth: '10rem',
    padding: '0.5rem 0',
    listStyle: 'none',
    backgroundColor: '#fff',
    right: ['reset', null, null, 0],
    left: [0, null, null, 'auto'],
    borderRadius: '3px',
  };

  const submenuStyles: object = depthLevel > 1 ? {
    position: 'absolute',
    left: '100%',
    top: '-7px'
  } : {};

  return (
    <ul
      sx={{
        ...styles,
        ...submenuStyles,
        display: dropdown ? 'block' : 'none'
      }}
    >
      {submenus.map((submenu, index) => (
        <MenuItems
          items={submenu}
          key={index}
          depthLevel={depthLevel}
        />
      ))}
    </ul>
  );
}
